// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "connect/scripts/wp-" + chunkId + "." + "dbc4e6091db4838b9c48" + ".js";
};